'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Accordion = require('./Accordion');

Object.defineProperty(exports, 'Accordion', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Accordion).default;
  }
});

var _AccordionTitle = require('./AccordionTitle');

Object.defineProperty(exports, 'AccordionTitle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccordionTitle).default;
  }
});

var _AccordionContent = require('./AccordionContent');

Object.defineProperty(exports, 'AccordionContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccordionContent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/accordion/index.js
// module id = 544
// module chunks = 0